import {
    ERROR,
    IDLE,
    LOADING,
    SUCCESS,
} from '@/shared/constants/loadingStatuses.constants';

export default {
    LOAD_PROFILE_START(state) {
        state.profile.loadingStatus = LOADING;
        state.profile.error = null;
    },

    LOAD_PROFILE_SUCCESS(state, { username, firstName, lastName }) {
        state.profile.username = username;
        state.profile.firstName = firstName;
        state.profile.lastName = lastName;
        state.profile.error = null;
        state.profile.loadingStatus = SUCCESS;
    },

    LOAD_PROFILE_EMAIL_SUCCESS(state, { mfaEmail }) {
        state.profile.mfaEmail = mfaEmail;
    },

    LOAD_PROFILE_NO_EMAIL(state) {
        state.profile.mfaEmail = null;
    },
    LOAD_PROFILE_SMS_SUCCESS(state, { mfaSms }) {
        state.profile.mfaSms = mfaSms;
    },

    LOAD_PROFILE_NO_SMS(state) {
        state.profile.mfaSms = null;
    },

    LOAD_PROFILE_APP_AUTH_SUCCESS(state, { mfaAppAuth }) {
        state.profile.mfaAppAuth = mfaAppAuth;
    },

    LOAD_PROFILE_NO_APP_AUTH(state) {
        state.profile.mfaAppAuth = null;
    },

    LOAD_PROFILE_SAVED_BROWSERS_SUCCESS(state, { browsers }) {
        state.profile.savedBrowsers = browsers;
    },

    LOAD_PROFILE_NO_SAVED_BROWSERS(state) {
        state.profile.savedBrowsers = [];
    },

    LOAD_PROFILE_INVITE_SUCCESS(state, { mfaInvited }) {
        state.profile.mfaInvited = mfaInvited;
    },

    LOAD_PROFILE_MIGRATION_STATUS(state, { isMigratedToThryv }) {
        state.profile.isMigratedToThryv = isMigratedToThryv;
    },

    LOAD_PROFILE_GOOGLE_ACCOUNT_STATUS(state, { hasGoogleAccount }) {
        state.profile.hasGoogleAccount = hasGoogleAccount;
    },

    LOAD_PROFILE_ERROR(state, error) {
        state.profile.error = error;
        state.profile.loadingStatus = ERROR;
    },

    UPDATE_MFA_START(state) {
        state.profile.error = null;
        state.profile.loadingStatus = IDLE;
        state.profile.mfaStatus = LOADING;
    },

    UPDATE_MFA_SUCCESS(state) {
        state.profile.error = null;
        state.profile.mfaStatus = IDLE;
    },

    UPDATE_MFA_ERROR(state, error) {
        state.profile.error = error;
        state.profile.mfaStatus = ERROR;
    },
};
